import * as yup from 'yup';

import { parseCurrencyIntoFloat } from 'app/utils/strings';

import { validateDate, validateSalaryRange } from 'app/utils/validations';

const individualPayrollFormSchema = yup.object().shape({
  annualGrossSalary: yup
    .number()
    .transform((_, originalValue) => {
      const parsedSalary = parseCurrencyIntoFloat(originalValue);
      return Number.isNaN(parsedSalary) ? undefined : parsedSalary;
    })
    .test(
      'Invalid salary range',
      'Salary must be between £4,000 and £500,000',
      (value) => value === undefined || validateSalaryRange(value)
    ),
  startDate: yup
    .string()
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
  salaried: yup.boolean(),
});

export default individualPayrollFormSchema;
